import { getBookingsRelativeUrl, queryBuilder, getUrlQueryParams, getSectionRelativeUrl, BOOKINGS_CALENDAR_SECTION_ID, isBookingsSectionInstalled, mapBasketToCalendarSelections, storeCalendarSelections, ReservedSlug } from '@wix/bookings-catalog-calendar-viewer-utils';
async function getBookingCalendarRelativeUrl(wixCodeApi) {
  if (await isBookingsSectionInstalled(wixCodeApi, BOOKINGS_CALENDAR_SECTION_ID)) {
    return getSectionRelativeUrl(wixCodeApi, BOOKINGS_CALENDAR_SECTION_ID);
  }
  return getBookingsRelativeUrl(wixCodeApi);
}
async function navigateToBookingsCalendarPageWithBasket(wixCodeApi, platformAPI, basket, navigationContext) {
  if (navigationContext === void 0) {
    navigationContext = {};
  }
  const calendarSelections = mapBasketToCalendarSelections(basket);
  storeCalendarSelections({
    calendarSelections,
    session: platformAPI.storage.session
  });
  return navigateToBookingsBookAction(wixCodeApi, {
    serviceSlug: ReservedSlug.DATE_AND_TIME,
    referral: navigationContext.referral,
    timezone: navigationContext.timezone,
    copyCurrentQueryParams: false
  });
}
async function getUrlSuffix(wixCodeApi, serviceSlug) {
  return (await isBookingsSectionInstalled(wixCodeApi, BOOKINGS_CALENDAR_SECTION_ID)) ? `/${serviceSlug}` : `/${serviceSlug}/book`;
}
async function navigateToBookingsBookAction(wixCodeApi, _temp) {
  let {
    serviceSlug,
    referral,
    staff,
    location,
    timezone,
    selections,
    resource,
    bookingId,
    copyCurrentQueryParams
  } = _temp === void 0 ? {} : _temp;
  copyCurrentQueryParams = copyCurrentQueryParams ?? true;
  const suffix = serviceSlug ? await getUrlSuffix(wixCodeApi, serviceSlug) : '';
  const query = queryBuilder({
    ...(copyCurrentQueryParams ? getUrlQueryParams(wixCodeApi) : {}),
    ...(serviceSlug ? {
      staff,
      timezone,
      location
    } : {
      selections
    }),
    referral,
    resource,
    bookingId
  });
  const bookingCalendarRelativeUrl = await getBookingCalendarRelativeUrl(wixCodeApi);
  wixCodeApi.location.to(`${bookingCalendarRelativeUrl}${suffix + query}`);
}
export async function navigateToBookingsCalendarPage(wixCodeApi, platformAPI, _ref) {
  let {
    serviceSlugOrBasket,
    navigationContext = {}
  } = _ref;
  if (typeof serviceSlugOrBasket === 'string' || serviceSlugOrBasket instanceof String) {
    return navigateToBookingsBookAction(wixCodeApi, {
      ...navigationContext,
      serviceSlug: serviceSlugOrBasket
    });
  } else {
    return navigateToBookingsCalendarPageWithBasket(wixCodeApi, platformAPI, serviceSlugOrBasket, navigationContext);
  }
}
//# sourceMappingURL=navigateToBookingsCalendarPage.js.map